"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _endpoints = require("./endpoints");
var _jsonp = _interopRequireDefault(require("jsonp"));
/**
 * @typedef CNPJData
 * @type {{
 *    "status": string;
 *    "ultima_atualizacao": string;
 *    "cnpj": string;
 *    "tipo": string;
 *    "porte": string;
 *    "nome": string;
 *    "fantasia": string;
 *    "abertura": string;
 *    "atividade_principal": {
 *        "code": string;
 *        "text": string
 *    }[];
 *    "atividades_secundarias": {
 *        "code": string;
 *        "text": string
 *    }[];
 *    "natureza_juridica": string;
 *    "logradouro": string;
 *    "numero": string;
 *    "complemento": string;
 *    "cep": string;
 *    "bairro": string;
 *    "municipio": string;
 *    "uf": string;
 *    "email": string;
 *    "telefone": string;
 *    "efr": string;
 *    "situacao": string;
 *    "data_situacao": string;
 *    "motivo_situacao": string;
 *    "situacao_especial": string;
 *    "data_situacao_especial": string;
 *    "capital_social": string;
 *    "qsa": {
 *        "nome": string;
 *        "qual": string;
 *        "pais_origem": string;
 *        "nome_rep_legal": string;
 *        "qual_rep_legal": string
 *    }[];
 *    "billing": {
 *        "free": boolean;
 *        "database": boolean
 *    }
 * }}
 */

var receitaApi = {
  /** 
   * @param {string} cnpj 
   * @returns {Promise<CNPJData>} 
   **/
  consult: function () {
    var _consult = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(cnpj) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              cnpj = cnpj.replace(/\D/g, "");
              (0, _jsonp["default"])("".concat(_endpoints.receita.baseURL, "/cnpj/").concat(cnpj), {
                timeout: _endpoints.receita.timeout
              }, function (err, data) {
                var hasError = err instanceof Error || (data === null || data === void 0 ? void 0 : data.status) !== "OK";
                if (hasError) return reject(err);else resolve(data);
              });
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function consult(_x) {
      return _consult.apply(this, arguments);
    }
    return consult;
  }()
};
var _default = receitaApi;
exports["default"] = _default;